export const createShape = (tokens) => {
    const { semantic: { radius }, } = tokens;
    return {
        borderRadius: parseInt(radius.lg.value),
    };
};
//# sourceMappingURL=shape.js.map